import PurchaseHistoryCouponCard from 'src/components/common/PurchaseHistoryCouponCard'

export const OnPossessionHistoryCouponCard = PurchaseHistoryCouponCard
